import type { BuilderContent } from "@builder.io/sdk-react";

import { isReferenceObjectWithValue } from "@/libs/builder/tools/isReferenceObjectWithValue";
import { getPathnameWithoutLocale } from "@/utils/getPathnameWithoutLocale";

import type { HeaderProps } from "./inputs/headerInputs.builder";

export const navLinksSecondaryNavigationAdapter = (
  navLinks: HeaderProps["navLinks"] = [],
  pathnameWithoutLocale: string,
  currentLocale: string
) =>
  navLinks.map(({ secondaryNavigation, ...rest }) => {
    const navLinkPath = getPathnameWithoutLocale(rest.url, currentLocale);

    const isActive = (() => {
      const isRoot = navLinkPath === "/";

      if (isRoot) {
        return pathnameWithoutLocale === navLinkPath;
      }

      return pathnameWithoutLocale.startsWith(navLinkPath);
    })();

    if (secondaryNavigation && isReferenceObjectWithValue<BuilderContent>(secondaryNavigation)) {
      return {
        ...rest,
        secondaryNavigation,
        isActive,
      };
    } else {
      return {
        ...rest,
        isActive,
      };
    }
  });
